import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { register, socialLogin, fetchUser } from '../../store/slices/authSlice';
import { Form, Button, Container, Card, Alert, Row, Col, ProgressBar, InputGroup } from 'react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';
import { FaHeart, FaEnvelope, FaPhone, FaEye, FaEyeSlash, FaSpinner, FaUser, FaCalendarAlt, FaShieldAlt, FaRocket, FaCheckCircle, FaUsers, FaChartLine, FaClock, FaLock } from 'react-icons/fa';
import { toast } from 'react-toastify';
import LandingNavbar from '../../components/layout/LandingNavbar';
import LandingFooter from '../../components/layout/LandingFooter';
import './Auth.css';


const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);

  const [activeTab, setActiveTab] = useState('email');
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    username: '',
    first_name: '',
    last_name: '',
    gender: '',
    date_of_birth: '',
    password: '',
    password_confirmation: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFormData({
      ...formData,
      email: tab === 'email' ? formData.email : undefined,
      phone: tab === 'phone' ? formData.phone : undefined
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    try {
      await dispatch(register(formData)).unwrap();
      navigate('/verify');
    } catch (err) {
      console.error('Registration failed:', err);
      // Handle validation errors
      if (err.errors) {
        setErrors(err.errors);
      } else {
        setErrors({ general: err.message || 'Erreur d\'inscription' });
      }
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const result = await dispatch(socialLogin({ provider: 'google', token: credentialResponse.credential })).unwrap();
      const user = result.user;

      if (user && user.profile && user.profile.is_complete) {
        toast.success('\u2705 Connexion Google r\u00e9ussie ! Bienvenue sur LOVA \ud83d\udc95');
        navigate('/home');
      } else {
        toast.success('\u2705 Compte Google cr\u00e9\u00e9 ! Compl\u00e9tez votre profil pour continuer \ud83d\udc95');
        navigate('/complete-profile');
      }
    } catch (err) {
      console.error('Google login failed:', err);
      setErrors({ general: err.message || 'Erreur de connexion Google' });
      toast.error('\u274c Inscription Google \u00e9chou\u00e9e');
    }
  };

  const handleGoogleError = () => {
    toast.error('\u274c Connexion Google annul\u00e9e ou \u00e9chou\u00e9e');
  };

  return (
    <div className="auth-page-wrapper">
      <LandingNavbar />
      <div className="auth-page">
        <Container>

        <Row className="justify-content-center py-5">
          <Col lg={5} xl={6}>
            <Card className="auth-card shadow-lg">
              <Row className="g-0">
                <Col md={12} className="auth-form-section">

                  <div className="auth-form-content">
                    <h3 className="auth-form-title">Créer votre profil LOVE</h3>
                    <p className="auth-form-subtitle">
                      Remplissez vos informations pour commencer
                    </p>

                    {/* Error Message */}
                    {errors.general && (
                      <Alert variant="danger" className="auth-alert">
                        <strong>Erreur :</strong> {errors.general}
                      </Alert>
                    )}

                    <Form onSubmit={handleSubmit} className="auth-form">
                      {/* Tabs for Email/Phone */}
                      <div className="auth-tabs mb-4">
                        <Button
                          type="button"
                          variant={activeTab === 'email' ? 'primary' : 'outline-secondary'}
                          className="me-2"
                          onClick={() => handleTabChange('email')}
                        >
                          <FaEnvelope className="me-1" /> Par Email
                        </Button>
                        <Button
                          type="button"
                          variant={activeTab === 'phone' ? 'primary' : 'outline-secondary'}
                          onClick={() => handleTabChange('phone')}
                        >
                          <FaPhone className="me-1" /> Par Téléphone
                        </Button>
                      </div>

                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label-custom">
                              Prénom *
                            </Form.Label>
                            <InputGroup>
                              <InputGroup.Text className="input-icon-group">
                                <FaUser />
                              </InputGroup.Text>
                              <Form.Control
                                type="text"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                required
                                className="form-control-custom"
                                placeholder="Votre prénom"
                              />
                            </InputGroup>
                            {errors.first_name && <div className="text-danger small">{errors.first_name[0]}</div>}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label-custom">
                              Nom *
                            </Form.Label>
                            <InputGroup>
                              <InputGroup.Text className="input-icon-group">
                                <FaUser />
                              </InputGroup.Text>
                              <Form.Control
                                type="text"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                required
                                className="form-control-custom"
                                placeholder="Votre nom"
                              />
                            </InputGroup>
                            {errors.last_name && <div className="text-danger small">{errors.last_name[0]}</div>}
                          </Form.Group>
                        </Col>
                      </Row>

                      {activeTab === 'email' && (
                        <Form.Group className="mb-3">
                          <Form.Label className="form-label-custom">
                            Email *
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text className="input-icon-group">
                              <FaEnvelope />
                            </InputGroup.Text>
                            <Form.Control
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              required
                              className="form-control-custom"
                              placeholder="votre@email.com"
                            />
                          </InputGroup>
                          {errors.email && <div className="text-danger small">{errors.email[0]}</div>}
                        </Form.Group>
                      )}

                      {activeTab === 'phone' && (
                        <Form.Group className="mb-3">
                          <Form.Label className="form-label-custom">
                            Téléphone *
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text className="input-icon-group">
                              <FaPhone />
                            </InputGroup.Text>
                            <Form.Control
                              type="tel"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              required
                              className="form-control-custom"
                              placeholder="+1 XXX XXX XXXX"
                            />
                          </InputGroup>
                          {errors.phone && <div className="text-danger small">{errors.phone[0]}</div>}
                        </Form.Group>
                      )}

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label-custom">
                          Nom d'utilisateur
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="input-icon-group">
                            <FaUser />
                          </InputGroup.Text>
                          <Form.Control
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            className="form-control-custom"
                            placeholder="Optionnel - sera généré automatiquement"
                          />
                        </InputGroup>
                        {errors.username && <div className="text-danger small">{errors.username[0]}</div>}
                      </Form.Group>

                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label-custom">
                              Genre *
                            </Form.Label>
                            <Form.Select
                              name="gender"
                              value={formData.gender}
                              onChange={handleChange}
                              required
                              className="form-control-custom"
                            >
                              <option value="">Sélectionnez</option>
                              <option value="male">Homme</option>
                              <option value="female">Femme</option>
                              <option value="other">Autre</option>
                            </Form.Select>
                            {errors.gender && <div className="text-danger small">{errors.gender[0]}</div>}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label-custom">
                              Date de naissance *
                            </Form.Label>
                            <Form.Control
                              type="date"
                              name="date_of_birth"
                              value={formData.date_of_birth}
                              onChange={handleChange}
                              required
                              className="form-control-custom"
                            />
                            {errors.date_of_birth && <div className="text-danger small">{errors.date_of_birth[0]}</div>}
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label-custom">
                          Mot de passe *
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="input-icon-group">
                            <FaShieldAlt />
                          </InputGroup.Text>
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="form-control-custom"
                            placeholder="Min 8 caractères"
                          />
                          <InputGroup.Text
                            className="input-icon-group password-toggle"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: 'pointer' }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </InputGroup.Text>
                        </InputGroup>
                        {errors.password && <div className="text-danger small">{errors.password[0]}</div>}
                      </Form.Group>

                      <Form.Group className="mb-4">
                        <Form.Label className="form-label-custom">
                          Confirmer le mot de passe *
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="input-icon-group">
                            <FaShieldAlt />
                          </InputGroup.Text>
                          <Form.Control
                            type={showConfirmPassword ? "text" : "password"}
                            name="password_confirmation"
                            value={formData.password_confirmation}
                            onChange={handleChange}
                            required
                            className="form-control-custom"
                            placeholder="Retapez votre mot de passe"
                          />
                          <InputGroup.Text
                            className="input-icon-group password-toggle"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            style={{ cursor: 'pointer' }}
                          >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>

                      <Button
                        type="submit"
                        className="btn-auth-submit w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Création de votre profil...
                          </>
                        ) : (
                          <>
                            <FaRocket className="me-2" />
                            Commencer l'aventure LOVE 💕
                          </>
                        )}
                      </Button>
                    </Form>

                    <div className="auth-divider">
                      <span>OU</span>
                    </div>

                    <div className="auth-social-buttons">
                      <div className="google-btn-wrapper mb-2">
                        <GoogleLogin
                          onSuccess={handleGoogleSuccess}
                          onError={handleGoogleError}
                          width="400"
                          shape="rectangular"
                          text="signup_with"
                          locale="fr"
                        />
                      </div>
                    </div>

                    <div className="auth-footer">
                      <p>
                        Déjà membre ?{' '}
                        <Link to="/login" className="auth-link">
                          Se connecter 💕
                        </Link>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>

        {/* Background Decoration */}
        <div className="auth-background">
          <div className="floating-heart heart-1">❤️</div>
          <div className="floating-heart heart-2">💕</div>
          <div className="floating-heart heart-3">💖</div>
          <div className="floating-heart heart-4">💗</div>
          <div className="floating-heart heart-5">💓</div>
          <div className="floating-heart heart-6">💘</div>
        </div>
      </div>
      <LandingFooter />
    </div>
  );

};

export default Register;
